export const END_OF_FEED_TYPE = 'post_end_of_feed';
export const SUGGESTED_GROUPS = 'post_suggested_groups';
export const END_OF_FEED_SESSION_STORAGE_KEY =
  'END_OF_FEED_SESSION_STORAGE_KEY';
